export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40c84cc072bd8f7ba57c475f225ed0f53951b8965b&name=revalidateCommunity!'